<template>
  <div class="mobile-nav-root hidden-sm-and-up">
    <header class="mobile-nav-header">
      <div class="mobile-nav-brand" @click="goHome">
        <img
          class="mobile-nav-logo-img"
          src="@/assets/img/home/logo.png"
          alt="鸿能"
        >
        <div class="mobile-nav-brand-text">
          <span class="brand-name">山东智能工业装备</span>
          <span class="brand-sub">有限公司</span>
        </div>
      </div>

      <div class="mobile-nav-actions">
        <a class="mobile-nav-phone" href="tel:0531-82899508" aria-label="拨打电话">
          <i class="el-icon-phone"></i>
        </a>
        <button
          class="mobile-nav-toggle"
          :class="{ 'is-open': menuShow }"
          type="button"
          aria-label="打开导航菜单"
          @click="toggleMenu"
        >
          <span class="toggle-bar"></span>
          <span class="toggle-bar"></span>
          <span class="toggle-bar"></span>
        </button>
      </div>
    </header>

    <transition name="fade">
      <div
        v-show="menuShow"
        class="mobile-nav-overlay"
        @click="closeMenu"
      ></div>
    </transition>

    <transition name="slide">
      <nav v-show="menuShow" class="mobile-nav-drawer">
        <div class="drawer-brand">
          <img
            class="drawer-brand-logo"
            src="@/assets/img/home/logo.png"
            alt="鸿能"
          >
          <div class="drawer-brand-text">
            <p class="drawer-brand-name">山东智能工业装备有限公司</p>
            <p class="drawer-brand-en">HONG NENG</p>
          </div>
        </div>

        <div class="drawer-scroll">
          <div
            v-for="item in navItems"
            :key="item.label"
            class="drawer-item"
          >
            <router-link
              v-if="!item.children"
              :class="{ active: currentActive === item.active }"
              class="drawer-link drawer-link--top"
              :to="item.path"
              @click.native="closeMenu"
            >
              {{ item.label }}
            </router-link>

            <div v-else class="drawer-group">
              <button
                type="button"
                :class="{ active: currentActive === item.active, expanded: expandedGroup === item.key }"
                class="drawer-link drawer-link--top drawer-link--parent"
                @click="toggleGroup(item.key)"
              >
                <span>{{ item.label }}</span>
                <i
                  class="el-icon-arrow-down drawer-arrow"
                  :class="{ rotated: expandedGroup === item.key }"
                ></i>
              </button>
              <transition name="expand">
                <div v-show="expandedGroup === item.key" class="drawer-sub">
                  <router-link
                    v-for="child in item.children"
                    :key="child.path"
                    class="drawer-link drawer-link--sub"
                    :to="child.path"
                    @click.native="closeMenu"
                  >
                    {{ child.label }}
                  </router-link>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <a class="drawer-phone" href="tel:0531-82899508">
          <i class="el-icon-phone"></i>
          <span>0531-82899508</span>
        </a>
      </nav>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  data () {
    return {
      menuShow: false,
      expandedGroup: null,
      navItems: [
        { label: '首页', path: '/home', active: 0 },
        {
          key: 'product',
          label: '产品',
          active: 1,
          children: [
            { label: '软件与AI', path: '/production/1' },
            { label: '新能源', path: '/production/2' },
            { label: '新装备', path: '/production/3' },
          ],
        },
        {
          key: 'content',
          label: '内容中心',
          active: 3,
          children: [
            { label: '行业报告', path: '/fournav/1' },
            { label: '精选文章', path: '/fournav/2' },
            { label: '媒体报道', path: '/fournav/3' },
          ],
        },
        { label: '关于我们', path: '/fivenav/1', active: 4 },
      ],
    }
  },
  watch: {
    $route () {
      this.closeMenu()
      this.syncExpandedGroup()
    },
    currentActive () {
      this.syncExpandedGroup()
    },
  },
  mounted () {
    this.syncExpandedGroup()
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  },
  methods: {
    toggleMenu () {
      this.menuShow = !this.menuShow
      document.body.style.overflow = this.menuShow ? 'hidden' : ''
      if (this.menuShow) {
        this.syncExpandedGroup()
      }
    },
    closeMenu () {
      this.menuShow = false
      document.body.style.overflow = ''
    },
    toggleGroup (key) {
      this.expandedGroup = this.expandedGroup === key ? null : key
    },
    syncExpandedGroup () {
      const groupMap = { 1: 'product', 3: 'content' }
      this.expandedGroup = groupMap[this.currentActive] || null
    },
    goHome () {
      this.closeMenu()
      this.$router.push('/home').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-nav-root {
  margin-bottom: 64PX;
}

.mobile-nav-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  height: 64PX;
  padding: 0 8PX 0 12PX;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8PX;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: saturate(180%) blur(12PX);
  box-shadow: 0 2PX 16PX rgba(0, 0, 0, 0.06);
}

.mobile-nav-brand {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10PX;
  cursor: pointer;
}

.mobile-nav-logo-img {
  width: 44PX;
  height: 44PX;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
}

.mobile-nav-brand-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.25;
}

.brand-name {
  font-size: 14PX;
  font-weight: 600;
  color: #1c212d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.brand-sub {
  margin-top: 2PX;
  font-size: 11PX;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-nav-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 2PX;
}

.mobile-nav-phone {
  width: 40PX;
  height: 40PX;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #005eae;
  text-decoration: none;
  border-radius: 50%;

  i {
    font-size: 20PX;
  }

  &:active {
    background: #f0f4f8;
  }
}

.mobile-nav-toggle {
  width: 40PX;
  height: 40PX;
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5PX;
  cursor: pointer;

  .toggle-bar {
    display: block;
    width: 22PX;
    height: 2PX;
    background: #1c212d;
    border-radius: 2PX;
    transition: transform 0.28s ease, opacity 0.2s ease, width 0.28s ease;
    transform-origin: center;
  }

  &.is-open {
    .toggle-bar:nth-child(1) {
      transform: translateY(7PX) rotate(45deg);
    }

    .toggle-bar:nth-child(2) {
      opacity: 0;
      width: 0;
    }

    .toggle-bar:nth-child(3) {
      transform: translateY(-7PX) rotate(-45deg);
    }
  }
}

.mobile-nav-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
}

.mobile-nav-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  width: min(82vw, 320PX);
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: -8PX 0 32PX rgba(0, 0, 0, 0.12);
}

.drawer-brand {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12PX;
  padding: 20PX 20PX 16PX;
  border-bottom: 1PX solid #f0f1f3;
  background: linear-gradient(180deg, #f8faf9 0%, #fff 100%);
}

.drawer-brand-logo {
  width: 52PX;
  height: 52PX;
  flex-shrink: 0;
  object-fit: contain;
}

.drawer-brand-text {
  min-width: 0;
}

.drawer-brand-name {
  margin: 0;
  font-size: 15PX;
  font-weight: 600;
  color: #1c212d;
  line-height: 1.4;
}

.drawer-brand-en {
  margin: 4PX 0 0;
  font-size: 12PX;
  letter-spacing: 0.08em;
  color: #2d6b4a;
  font-weight: 500;
}

.drawer-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 8PX 0 16PX;
  -webkit-overflow-scrolling: touch;
}

.drawer-group {
  border-bottom: none;
}

.drawer-item {
  border-bottom: 1PX solid #f0f1f3;
}

.drawer-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16PX 20PX;
  font-size: 16PX;
  color: #1c212d;
  text-decoration: none;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  box-sizing: border-box;

  &--top {
    border-bottom: none;
  }

  &--parent {
    font-weight: 500;
  }

  &--sub {
    padding: 14PX 20PX 14PX 36PX;
    font-size: 15PX;
    color: #666;
    background: #f7f8fa;

    &:active {
      background: #eef0f3;
    }
  }

  &.active {
    color: #f39c00;
    font-weight: 600;
    box-shadow: inset 3PX 0 0 #f39c00;
  }

  &:active {
    background: #f7f8fa;
  }
}

.drawer-arrow {
  font-size: 14PX;
  color: #999;
  transition: transform 0.28s ease;

  &.rotated {
    transform: rotate(180deg);
  }
}

.drawer-sub {
  overflow: hidden;
}

.drawer-phone {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8PX;
  padding: 18PX 20PX;
  border-top: 1PX solid #f0f1f3;
  background: #fafbfc;
  color: #005eae;
  font-size: 15PX;
  font-weight: 500;
  text-decoration: none;

  i {
    font-size: 18PX;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}

.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.28s ease, opacity 0.24s ease;
  max-height: 200PX;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
